import { loadById } from './sequences'

export const loadProfilesSequence = (mobileUserIdsQuery, idsType = 'mobileUserIds') => [
  (context) => ({ [idsType]: mobileUserIdsQuery(context) || [] }),
  loadById,
]
